import styled from 'styled-components';
import { Typography } from '@mui/material';

import FooterImg from '~/assets/images/logo-gmo_research.png';

type WrapperProps = {
  $height?: string;
};

const Wrapper = styled.div<WrapperProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 31px 75px 31px 63px;
  width: 100%;
  height: ${({ $height }) => $height};
  position: absolute;
  bottom: 0;
`;

const StyledText = styled(Typography)`
  color: #888;
`;

type Props = {
  height?: string;
};

// eslint-disable-next-line react/prop-types
const Footer: React.FC<Props> = ({ height = 'auto' }): JSX.Element => (
  <Wrapper $height={height} data-testid="uiParts-Footer">
    <StyledText variant="note1" data-testid="uiParts-Footer-copyrights">
      Copyright © GMO Research & AI, Inc. All Rights Reserved.
    </StyledText>
    <div>
      <img
        width="208px"
        src={FooterImg}
        alt="Copyright ©GMO Research & AI"
        title="Copyright ©GMO Research & AI"
      />
    </div>
  </Wrapper>
);

export default Footer;
